import React from 'react';
import classnames from 'classnames';
import s from './Interests.scss';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface Props {
  interests: {
    id: number;
    value: string;
  }[];
  className?: string;
}

class Interests extends React.Component<Props & WithTranslation> {
  render() {
    return (
      <div className={classnames(s['root'], this.props.className)}>
        {this.props.interests.map(interest => (
          <div key={interest.id} className={s['interest-group']}>
            <div className={s['interest-label']}>
              {this.props.t!(`widgets.aboutMe.interests.${interest.id}`)}
            </div>
            <div className={s['interest-value']}>{interest.value}</div>
          </div>
        ))}
      </div>
    );
  }
}

export default withTranslation()(Interests);
